import { motion } from 'framer-motion';
import { useState } from 'react';
import Breadcrumb from '../components/Breadcrumb';

const galleryItems = [
  {
    id: 1,
    category: "Academic",
    image: "https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=800",
    caption: "Students in the classroom"
  },
  {
    id: 2,
    category: "Sports",
    image: "/images/sportsday.jpg",
    caption: "Annual sports day"
  },
  {
    id: 3,
    category: "Events",
    image: "/images/Celebrations.jpg",
    caption: "School celebrations"
  },
  {
    id: 4,
    category: "STEM",
    image: "/images/STEM2.jpg",
    caption: "Science fair projects"
  },
  {
    id: 5,
    category: "Arts",
    image: "/images/ART.jpg",
    caption: "Art exhibition"
  },
  {
    id: 6,
    category: "Events",
    image: "/images/graduation.jpg",
    caption: "Graduation ceremony"
  }
];

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);

  const filteredGallery = selectedCategory === 'all'
    ? galleryItems
    : galleryItems.filter(item => item.category.toLowerCase() === selectedCategory);

  const categories = ['all', ...new Set(galleryItems.map(item => item.category.toLowerCase()))];

  return (
    <div className="min-h-screen bg-gray-50">
      <Breadcrumb crumbs={[
        { name: 'Home', href: '/' },
        { name: 'Photo Gallery', href: '/gallery' },
      ]} />
      <div className="py-12">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold mb-4">Photo Gallery</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore moments and memories from our school community
          </p>
        </motion.div>

        {/* Category Filter */}
        <div className="flex justify-center flex-wrap gap-4 mb-8">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-4 py-2 rounded-full transition-colors
                ${selectedCategory === category 
                  ? 'bg-primary text-dark' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredGallery.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="relative group cursor-pointer"
              onClick={() => setSelectedImage(item)}
            >
              <div className="aspect-w-4 aspect-h-3 rounded-lg overflow-hidden">
                <img 
                  src={item.image} 
                  alt={item.caption}
                  className="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-50 transition-opacity flex items-end">
                <div className="p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                  <p className="text-sm font-medium">{item.category}</p>
                  <p className="text-lg">{item.caption}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Image Modal */}
        {selectedImage && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              className="relative max-w-4xl w-full"
              onClick={e => e.stopPropagation()}
            >
              <img
                src={selectedImage.image}
                alt={selectedImage.caption}
                className="w-full h-auto rounded-lg"
              />
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-black bg-opacity-50 text-white rounded-b-lg">
                <p className="text-sm font-medium">{selectedImage.category}</p>
                <p className="text-lg">{selectedImage.caption}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </div>      </div>    </div>
  );
};

export default Gallery;